import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSliderRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.168 17.103a.898.898 0 1 1 1.796 0 .898.898 0 0 1-1.796 0Zm-1.822-1.001a2.899 2.899 0 0 1 5.44 0H20a1 1 0 0 1 0 2h-2.213a2.899 2.899 0 0 1-5.442 0H4a1 1 0 1 1 0-2h8.346Zm-3.412-3.207a.898.898 0 1 0 0-1.795.898.898 0 0 0 0 1.795ZM20 11h-8.345a2.899 2.899 0 0 0-5.442 0H4a1 1 0 1 0 0 2h2.214a2.899 2.899 0 0 0 5.44 0H20a1 1 0 1 0 0-2Zm-4.934-1.21c-1.25 0-2.314-.79-2.721-1.898H4a1 1 0 0 1 0-2h8.346a2.899 2.899 0 0 1 5.44 0H20a1 1 0 0 1 0 2h-2.213a2.899 2.899 0 0 1-2.721 1.898Zm-.898-2.897v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSliderRound);
export default Memo;
